import React from "react";
import { Navigate } from "react-router-dom";
import { safeGetFromLocalStorage } from "../../helper-functions/safeJSONParse";

const ZoneGuard = ({ children }) => {
  const zoneId = safeGetFromLocalStorage("zoneid", null);

  if (!zoneId) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ZoneGuard;
